import { observer } from "mobx-react";
import React from "react";
import { IWeeklySalesAndPaymentDetailVMRow } from "../../../models/response/ITotallingManagementResponse";
import { FormattedMessage } from "react-intl";
import { showAmountWithFormatting } from "../../../helpers/common-component-helper";

interface IProps {
  data: IWeeklySalesAndPaymentDetailVMRow[];
}

const WeeklySalesAndPaymentDetail: React.FC<IProps> = ({ data }) => {

  const paymentKeys = data.length > 0 ? Object.keys(data[0].Payments) : [];

  return (
    <div className="table-responsive all-day-table mb-4">
      <table className="table table-bordered table-striped text-center align-middle">
        <thead className="table-primary">
          <tr>
            <th rowSpan={2}>
              <FormattedMessage id="date" />
            </th>
            <th rowSpan={2}>
              <FormattedMessage id="total_sales" /> <br />
              <small>(<FormattedMessage id="unit_price" />)</small>
            </th>
            <th rowSpan={2}><FormattedMessage id="total_customers" /></th>
            <th colSpan={2}><FormattedMessage id="sales_composition" /></th>
            <th rowSpan={2}><FormattedMessage id="discount" /></th>
            <th rowSpan={2}><FormattedMessage id="total_tax_amount" /></th>
            <th rowSpan={paymentKeys.length == 0 ? 2 : 1} colSpan={paymentKeys.length}><FormattedMessage id="payment_method_used" /></th>
          </tr>
          <tr>
            <th>
              <FormattedMessage id="treatment_sales" /> <br />
              {/* <small>(avg)</small> */}
            </th>
            <th>
              <FormattedMessage id="product_sales" /> <br />
              {/* <small>(avg)</small> */}
            </th>
            {paymentKeys.map((key) => (
              <th key={key}>
                {key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr
              key={i}
              className={row.Date === "Total" ? "fw-bold table-success" : ""}
            >
              <td>{row.Date}</td>
              <td>
                {showAmountWithFormatting(row.TotalSales)}
                <br />
                <small>({showAmountWithFormatting(row.AvgTotalSales)})</small>
              </td>
              <td>{row.TotalCustomers}</td>
              <td>
                {showAmountWithFormatting(row.TreatmentSales)}
                <br />
                <small>({showAmountWithFormatting(row.AvgTreatmentSales)})</small>
              </td>
              <td>
                {showAmountWithFormatting(row.ProductSales)}
                <br />
                <small>({showAmountWithFormatting(row.AvgProductSales)})</small>
              </td>
              <td>{showAmountWithFormatting(row.Discount)}</td>
              <td>{showAmountWithFormatting(row.TaxAmount)}</td>
              {paymentKeys.map((key) => (
                <td key={key}>{showAmountWithFormatting(row.Payments[key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default observer(WeeklySalesAndPaymentDetail);
